import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";

import { BRAND_STAYSURE } from "@/constants";
import { RootState } from "@/store/root-reducer";

export function useCancellationCoverApiErrorModal(brand?: string) {
  const { attributes } = useSelector((s: RootState) => s.quote);
  const [show, setShow] = useState(false);
  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      return;
    }
    const shouldShow = !attributes.priceResult && brand === BRAND_STAYSURE;
    setShow(shouldShow);
  }, [attributes.priceResult, brand]);

  return show;
}
